import type {
  AdminAutomationRuleQuotaResponse,
  UpdateAutomationRuleQuotaRequest,
} from '@/api/(admin)/automation-rule-quota/types';
import { BACKEND_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

export async function fetchCompanyRuleQuota(
  companyId: string,
): Promise<AdminAutomationRuleQuotaResponse> {
  return apiFetch<AdminAutomationRuleQuotaResponse>(
    `/admin/companies/${companyId}/automation-rule-quota`,
    {},
    BACKEND_URL,
  );
}

export async function updateCompanyRuleQuota(
  companyId: string,
  payload: UpdateAutomationRuleQuotaRequest,
): Promise<AdminAutomationRuleQuotaResponse> {
  return apiFetch<AdminAutomationRuleQuotaResponse>(
    `/admin/companies/${companyId}/automation-rule-quota`,
    { method: 'PUT', body: JSON.stringify(payload) },
    BACKEND_URL,
  );
}
